/** Ports the workbook's "Median PRV %" CF (O4:O15/O18:O24): a plain >=30% threshold, not a gradient. */

const PRV_GOOD_THRESHOLD = 30;

/** value is a percentage number (e.g. 34, not 0.34), matching this module's other PRV%/discount fields. */
export function computePrvThresholdColor(value: number): { bgcolor: string; color?: string } {
  if (value >= PRV_GOOD_THRESHOLD) {
    return { bgcolor: 'rgb(197, 224, 180)', color: 'rgb(56, 87, 36)' };
  }
  return { bgcolor: 'rgb(255, 197, 198)' };
}
